import React, {
    PropsWithChildren,
    useRef,
    CSSProperties,
    Dispatch,
    SetStateAction,
} from 'react';
import {
    DatePicker,
    IDatePicker,
    defaultDatePickerStrings,
} from '@fluentui/react';

interface IDateRangeDropDownProps extends PropsWithChildren<any> {
    startDate?: string;
    setStartDate?: Dispatch<SetStateAction<string | undefined>>;
    endDate?: string;
    setEndDate?: Dispatch<SetStateAction<string | undefined>>;
    isStartDate: boolean;
    placeholder?: string;
    alignToGrid?: boolean;
}

export const DateRangeDropDown: React.FC<IDateRangeDropDownProps> = (
    props: IDateRangeDropDownProps
) => {
    const datePickerRef = useRef<IDatePicker>(null);

    const setDateValue = props.isStartDate
        ? props.setStartDate
        : props.setEndDate;

    const toDate = (value?: string): Date | undefined =>
        value && !isNaN(Date.parse(value)) ? new Date(value) : undefined;

    const startDateObj = toDate(props.startDate);
    const endDateObj = toDate(props.endDate);
    const dateObj = props.isStartDate ? startDateObj : endDateObj;

    const onSelectDate = (date: Date | null | undefined) => {
        if (setDateValue) {
            if (date) {
                setDateValue(date.toUTCString());
            } else {
                setDateValue(undefined);
            }
        }
    };

    const divStyles: CSSProperties = {
        marginTop: props.alignToGrid ? 0 : '5px',
        marginLeft: props.alignToGrid ? 0 : '5px',
        marginRight: props.alignToGrid ? 0 : '5px',
    };

    return (
        <div style={divStyles}>
            <DatePicker
                componentRef={datePickerRef}
                placeholder={
                    props.placeholder ||
                    (props.isStartDate
                        ? 'Search Range Start'
                        : 'Search Range End')
                }
                allowTextInput
                value={dateObj}
                minDate={props.isStartDate ? undefined : startDateObj}
                maxDate={props.isStartDate ? endDateObj : undefined}
                ariaLabel="Select a Date"
                onSelectDate={onSelectDate}
                strings={defaultDatePickerStrings}
            />
        </div>
    );
};
